import { withTranslation, useTranslation, Trans } from 'react-i18next';
import i18n from './i18n';

export {
  withTranslation, useTranslation, i18n, Trans,
};
